'use strict';

Object.defineProperty(exports, '__esModule', {
		value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var Crumb = function Crumb(props) {
		return _react2['default'].createElement(
				'li',
				{ className: props.className },
				props.href !== undefined ? _react2['default'].createElement(
						'a',
						{ href: props.href },
						props.children
				) : _react2['default'].createElement(
						'span',
						null,
						props.children
				)
		);
};

exports['default'] = Crumb;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/_rs-breadcrumb@0.1.1@rs-breadcrumb/dist/crumb.js
// module id = 1910
// module chunks = 0